import React from 'react';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import Label from 'components/form/Label/Label';
import { Link } from 'components/navigation/Link/Link';
import { SUGGESTED_PERSONAL_LOAN_OFFERS } from 'types/morph.pagePosition.constants';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { LOANS_PERSONAL } from 'types/mrph.pageName.constants';

const SuggestedPersonalLoanOffersView = ({
  pageName,
  personalLoans,
  onLinkClickCallback,
  modulePosition,
  ...props
}) => {
  const atr = getViewModuleTrackingAttributes(
    SUGGESTED_PERSONAL_LOAN_OFFERS,
    modulePosition,
  );
  useViewModule(atr, true);
  const seenPixel = useSeenModulePixel(atr);
  const topPersonalLoan = personalLoans.slice(0, 1);
  return (
    <div>
      {seenPixel}
      <Row
        datatestid={`${pageName}-suggestedPersonalLoanOffers`}
        className={`${pageName}-suggestedPersonalLoanOffers`}
      >
        <TitleContainer datatestid={`${pageName}-offers`}>
          <Label
            type="H3"
            typeHeader={'h3'}
            className="margB8"
            datatestid="offers"
          >
            Suggested loan offer for you!
          </Label>
        </TitleContainer>
        <StaticOfferContainer
          eventHandler={props.eventHandler}
          datatestid={props.datatestid}
          offerMetadataList={topPersonalLoan}
          pagePosition={SUGGESTED_PERSONAL_LOAN_OFFERS}
          modulePosition={modulePosition}
        />
        <div className="padB16" />
        <FlexContainer className="justify-end mobile-justify-center">
          <Link
            onClickCallback={onLinkClickCallback}
            location={LOANS_PERSONAL}
            to="/offers?vertical=PERSONAL_LOAN"
          >
            <Label type="Subtitle-2 link">See more Personal Loan offers</Label>
          </Link>
        </FlexContainer>
      </Row>
    </div>
  );
};

export { SuggestedPersonalLoanOffersView };
